import useHsCrmApi from "../../hooks/useHsCrmApi";
import useRecordServiceMethods from "../../services/recordService";
import useSegmentService from "../../services/segmentService";
import useMetaService from "../../services/metaService";
import useImportService from "../../services/importService";

const useRecordService = () => {
  const { api } = useHsCrmApi();

  const recordServiceMethods = useRecordServiceMethods(api);
  const segmentServiceMethods = useSegmentService(api);
  const metaServiceMethods = useMetaService(api);
  const importServiceMethods = useImportService(api);

  return {
    ...recordServiceMethods,
    ...segmentServiceMethods,
    ...metaServiceMethods,
    ...importServiceMethods,
  };
};

export default useRecordService;
